import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getProjectMembersList} from "../../redux/actions/projects/projectsActions";
import {hasPermission} from "../../helpers/functions";
import {PERMISSIONS} from "../../helpers/constants";

export const useFetchProjectMembers = (singleProjectId, projectMembersList, projectMembersListLoading) => {
    const dispatch = useDispatch();
    const profileMe = useSelector((state) => state.profile.profileMe);
    const hasPermissionMembers = hasPermission(PERMISSIONS.MEMBER_PROJECT_LIST, profileMe?.permissions ?? []);

    useEffect(() => {
        if (!projectMembersList?.length && projectMembersListLoading && hasPermissionMembers ) {
            dispatch(getProjectMembersList(singleProjectId));
        }
    }, [dispatch, singleProjectId, projectMembersListLoading, projectMembersList,hasPermissionMembers]);
};
